import { getJson } from "./client";

// Identity surface returned by GET /api/me. Mirrors the backend's
// UserClaims shape (paim/portal/auth.py) — keep these in sync.

export interface MeResponse {
  sub: string;
  email: string | null;
  name: string | null;
  role: "admin" | "user";
  groups: string[];
  // S3 bucket the wizard uses to seed the default output prefix.
  // Set per-deployment via PAIM_DEFAULT_OUTPUT_BUCKET; null in
  // open-mode dev or when the deployer didn't configure one.
  default_output_bucket: string | null;
  // S3 bucket the operator indexes from — used by the wizard as the
  // read (archive) bucket for batch_export. Set per-deployment via
  // PAIM_DEFAULT_ARCHIVE_BUCKET; null when unconfigured (in which
  // case the wizard's submit step disables until the user fills it).
  default_archive_bucket: string | null;
  // Cost-attribution rates surfaced from the portal config so the SPA
  // can render per-job / per-workflow $-cost without a separate
  // round-trip per page.
  cost_cpu_hr_usd: number;
  cost_mem_gib_hr_usd: number;
  // Feature gates. Same shape as PortalConfig.features but echoed
  // through /api/me so already-authed pages don't have to refetch
  // the pre-auth bootstrap endpoint. Optional so older portals
  // without the field still parse.
  features?: {
    ai_query_builder: boolean;
  };
}

export function getMe(): Promise<MeResponse> {
  return getJson<MeResponse>("/api/me");
}
